import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { IconEmoji } from '@tribeplatform/react-components/common';
import { HtmlContent } from '@tribeplatform/react-components/HtmlContent';
import { useRouter } from '@tribeplatform/react-sdk';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Card } from '@tribeplatform/react-ui-kit/Card';
const Action = ({ action }) => {
    const { Link } = useRouter();
    if (!action)
        return null;
    const { href, text, type, openInNewWindow } = action;
    if (!text)
        return null;
    const target = openInNewWindow ? '_blank' : undefined;
    const props = {
        href,
        target,
        className: 'inline-block truncate',
    };
    if (type === 'link') {
        return _jsx(Link, { ...props, children: text }, void 0);
    }
    return (_jsx(Button, { as: props => _jsx(Link, { ...props, variant: "inherit" }, void 0), ...props, children: text }, void 0));
};
export const CallToAction = ({ alignment, title, description, image, action, className, style, }) => {
    var _a, _b, _c;
    let emoji;
    let img;
    if ((_a = image) === null || _a === void 0 ? void 0 : _a.url) {
        img = image;
    }
    else if ((_b = image) === null || _b === void 0 ? void 0 : _b.text) {
        emoji = image;
    }
    return (_jsxs(Card, { className: clsx('overflow-hidden', className), style: style, children: [img && (_jsx("div", { className: "bg-cover", style: {
                    aspectRatio: '11/4',
                    backgroundColor: img.dominantColorHex,
                    backgroundImage: `url(${((_c = img.urls) === null || _c === void 0 ? void 0 : _c.medium) || img.url})`,
                } }, void 0)), emoji && (_jsx("div", { className: "pt-3 justify-center items-center flex", children: _jsx(IconEmoji, { text: emoji.text, size: "xl" }, void 0) }, void 0)), _jsxs(Card.Content, { className: clsx('space-y-3', alignment === 'center' ? 'text-center' : 'text-left'), children: [title && _jsx("h4", { className: "text-basicSurface-700", children: title }, void 0), description && (_jsx("article", { children: _jsx(HtmlContent, { value: description, trustedDomains: ['*'] }, void 0) }, void 0))] }, void 0), _jsx(Card.Footer, { className: clsx(alignment === 'center' ? 'text-center' : 'text-left'), children: _jsx(Action, { action: action }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=index.js.map